(() => {
  const marketLocales = Object.freeze({
    DK: 'da',
    DE: 'de',
    ES: 'es',
    FR: 'fr',
    GB: 'en',
    IT: 'it',
    NL: 'nl',
    NO: 'nb',
    PL: 'pl',
    PT: 'pt-PT',
    SE: 'sv'
  });

  const localePrefixes = new Set(['da', 'de', 'en', 'es', 'fr', 'it', 'nb', 'nl', 'pl', 'pt', 'sv']);

  function localeForCountry(countryCode) {
    return marketLocales[String(countryCode || '').toUpperCase()] || null;
  }

  function hasExplicitLocalePrefix(pathname = '/') {
    const firstSegment = String(pathname).split('/').filter(Boolean)[0]?.toLowerCase();
    return Boolean(firstSegment && localePrefixes.has(firstSegment));
  }

  function shouldAutoLocalize({ pathname, currentCountry, currentLanguage, detectedCountry }) {
    if (hasExplicitLocalePrefix(pathname)) return false;

    const normalizedDetectedCountry = String(detectedCountry || '').toUpperCase();
    const targetLanguage = localeForCountry(normalizedDetectedCountry);
    if (!targetLanguage) return false;

    return (
      String(currentCountry || '').toUpperCase() !== normalizedDetectedCountry
      || String(currentLanguage || '').toLowerCase() !== targetLanguage.toLowerCase()
    );
  }

  globalThis.KiddyViewLocalizationLogic = Object.freeze({
    hasExplicitLocalePrefix,
    localeForCountry,
    shouldAutoLocalize
  });
})();
